import React, { useEffect, useState } from "react";
import { PackageCheck, Loader2 } from "lucide-react";
import { fmtDT } from "../../lib/date";

/* 收货记录：扫码收货核对生成（谁 / 何时 / 哪些到货单 / 实收 vs 应收差异） */
export const ReceiptsList = ({ api, zh, wid, refreshKey }) => {
  const T = (a, b) => (zh ? a : b);
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/wms/receipts", { params: { wid, limit: 30 } }).then((r) => setList(r.data)).catch(() => setList([])); }, [api, wid, refreshKey]);
  return (
    <div className="bg-white rounded-xl border border-slate-200" data-testid="wh-receipts" data-count={list?.length ?? -1}>
      <p className="px-4 py-2 text-xs font-semibold text-slate-600 border-b border-slate-100 inline-flex items-center gap-1.5"><PackageCheck className="h-3.5 w-3.5 text-lime-700" />{T("扫码收货记录", "Scan receipts")}<span className="text-slate-400 font-normal">{list ? list.length : "…"}</span></p>
      {!list ? <p className="p-3"><Loader2 className="h-3 w-3 animate-spin text-slate-400" /></p> : list.length === 0 ? <p className="px-4 py-3 text-xs text-slate-400" data-testid="wh-receipts-empty">{T("暂无扫码收货记录（在扫码工作台「扫码收货」提交后出现）", "No scan receipts yet")}</p> : (
        <div className="divide-y divide-slate-50">
          {list.map((r) => (
            <div key={r.id} className="px-4 py-2 text-xs" data-testid={`wh-receipt-${r.id}`}>
              <p className="text-slate-700"><span className="font-mono font-semibold">{r.id}</span> · {r.by} · {fmtDT(r.createdAt)} · {T(`确认 ${r.okCount} 单`, `${r.okCount} ok`)}{r.diffCount ? <span className="text-amber-700">{T(`，少收 ${r.diffCount} 单`, `, ${r.diffCount} partial`)}</span> : ""}{r.blockedCount ? <span className="text-red-600">{T(`，拦截 ${r.blockedCount} 行`, `, ${r.blockedCount} blocked`)}</span> : ""}</p>
              <p className="text-[10px] text-slate-400 mt-0.5">{(r.lines || []).map((l) => `${l.name} ${T("应收", "exp")} ${l.expected} / ${T("实收", "got")} ${l.counted}${l.ok ? (l.diff ? ` (${l.diff})` : "") : ` ✕ ${l.error}`}`).join("；")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
